import { BrowserRouter as Router, Route, Switch } from "react-router-dom";


import "./App.css";
import DetailPage from "./pages/DetailPage";
import HomePage from "./pages/HomePage";


function App() {

  return (
    <div className="app">
      <Router>
        <Switch>
          <Route path="/" exact component={HomePage} excat></Route>
          <Route path="/:id" exact component={DetailPage} excat></Route>
        </Switch>
      </Router>
      <h3 className="footer">
        Copyright &copy; 2021 NrrHtgYinHlu. All Rights Reserved
      </h3>
    </div>
  );
}

export default App;
